<app-back-header
  [headerText]="'Torna alla dashboard'"
  (backAction)="backToDashboard()"
  class="sticky-top">
</app-back-header>

<h3 class="ms-2 mt-2">Notifiche e avvisi</h3>

<!-- Filter chips: stessa grammatica delle chip di filtro della tabella fatture
     (pill con contorno 2px, selezionata in petrol pieno). -->
<mat-chip-set aria-label="Filtro notifiche" class="ms-1 status-chip-set">
  <mat-chip-option
    [selected]="!activeFilters.unread"
    (click)="showAllMessages()">
    In arrivo
  </mat-chip-option>
  <!-- <mat-chip-option
    (click)="toggleAttachmentFilter()">
    Con allegato
  </mat-chip-option> -->
  <mat-chip-option
    [selected]="activeFilters.unread"
    (click)="toggleUnreadFilter()">
    Da leggere ({{toReadMessages}})
  </mat-chip-option>
</mat-chip-set>

<h5 class="ms-2 mt-2">Posta in arrivo</h5>
<p class="ms-2">Clicca su un elemento per espanderne il contenuto.</p>

<!-- messages.component.html -->
<div class="messages-container">

  <!-- Loading State -->
  <div *ngIf="loading" class="loading-container">
    <mat-progress-spinner diameter="50" mode="indeterminate"></mat-progress-spinner>
    <p class="mt-3">Caricando notifiche e avvisi...</p>
  </div>

  <!-- Error State -->
  <div *ngIf="error && !loading" class="error-container">
    <mat-icon>error_outline</mat-icon>
    <p>{{ error }}</p>
    <button
      matButton="filled"
      class="izy-button-primary custom-button-border"
      (click)="loadMessages()">
      <mat-icon>refresh</mat-icon>
      Riprova
    </button>
  </div>

  <!-- Empty State -->
  <div *ngIf="!loading && !error && messages.length === 0" class="empty-container">
    <mat-icon>inbox</mat-icon>
    <h3>Nessun elemento trovato</h3>
    <p>Niente da leggere al momento.</p>
  </div>

  <!-- Messages List -->
  <div *ngIf="!loading && !error && messages.length > 0" class="messages-list pb-3">

    <!-- Card notifica: superficie piatta bianca con bordo nero 2px e angolo
         basso-sinistra vivo, come le card fattura/cliente/prodotto su mobile
         (utility globali .custom-card-border / .izy-sharp-bl in styles.scss).
         La notifica da leggere e' marcata dalla fascia lime a sinistra, il
         segnale "da leggere" del linguaggio BEIZY. -->
    <mat-card
      *ngFor="let message of messages"
      class="message-item izy-sharp-bl custom-card-border"
      [class.message-item--unread]="message.is_read === false"
      (click)="openMessageDetail(message)">

      <mat-card-header class="message-header">
        <div class="d-flex justify-content-between align-items-center w-100">
          <div class="message-icon d-flex align-items-center">
            <mat-icon>{{ getMessageTypeIcon(message.type) }}</mat-icon>
            <mat-chip-set class="ms-2" *ngIf="message.is_read === false">
              <mat-chip class="new-message-chip me-0">
                Nuovo
              </mat-chip>
            </mat-chip-set>
          </div>

          <span class="message-date">
            {{ message.date | date:'dd/MM/yyyy' }}
          </span>
        </div>
      </mat-card-header>

      <mat-card-content class="message-content">
        <div class="message-title" [class.message-title--unread]="message.is_read === false">
          {{ message.title || 'Nessun titolo' }}
        </div>

        <div class="message-sender">
          Da: {{ message.sender || 'Sconosciuto' }}
        </div>

        <div class="message-text">
          {{ truncateText(message.message, 100) }}
        </div>
      </mat-card-content>

      <!-- Footer su fondo panna separato dal tratto nero 2px, come il footer
           delle card fattura/cliente: e' l'unica zona non bianca della card e
           ospita il comando secondario. -->
      <div
        *ngIf="hasAttachment(message)"
        class="d-flex justify-content-end align-items-center message-card-footer">
        <button
          mat-stroked-button
          class="me-2 message-attachment-btn custom-button-border"
          (click)="downloadAttachment(message, $event)"
          matTooltip="Apri l'allegato della notifica.">
          <mat-icon>attach_file</mat-icon>
          Vedi allegato
        </button>
      </div>

    </mat-card>
  </div>
</div>
